import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import UserPanelFull from '../containers/UserPanelFull';
import UserPanelNarrow from '../containers/UserPanelNarrow';

const UserPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: UserPanelFull, narrow: UserPanelNarrow }}
    onChange={onChange}
  />
);

export default UserPanel;
